import React, { Component } from 'react'
import car from '../images/01-Startpage-Vehicle-01-PKW.png';

import { withCookies } from 'react-cookie';
import { withTranslation } from "react-i18next";
class Vehicle extends Component {
    render() {
    const { t } = this.props;
    return (
      <div className="vehicle-part">
        <h4>{t("vehicle.title")}</h4>
        <div className="row">
          <div className="col-sm-4">
            <div className="vehicle-car">
              <img src=" https://www.osram.com.cn/apps/cvlrg/static/media/01-Startpage-Vehicle-01-PKW.d0eca108.png" alt={t("vehicle.car")} onLoad={() => this.props.setKind(1)} />
              <button onLoad={() => this.props.setKind(1)}>{t("vehicle.car")}</button>
            </div>
          </div>
        </div>
      </div>

    )

  }
}

const cookieWrap = withCookies(Vehicle);
export default withTranslation()(cookieWrap);
//export default withCookies(Vehicle);